import { useUpdateVacancyModal } from "@/features/update-vacancy"
import { IJobOpening } from "@/shared/api/employment"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchVacancies } from "../../model"
import EditSvg from '@/shared/assets/images/Pencil.svg'
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"

interface UpdateVacancyProps {
    vacancy: IJobOpening
}

export const UpdateVacancy: FC<UpdateVacancyProps> = ({ vacancy }) => {
    const { openUpdateVacancyModal } = useUpdateVacancyModal()
    const dispatch = useAppDispatch()

    const onDelete = () => {
        dispatch(fetchVacancies())
    }

    return (
        <DropdownItem 
            onClick={() => openUpdateVacancyModal(vacancy, onDelete)}
            icon={EditSvg}
            label="Редактировать" 
        />
    )
}